(() => {
  const initProduct = (root) => {
    const slides = Array.from(root.querySelectorAll('[data-gd-product-slide]'));
    const thumbs = Array.from(root.querySelectorAll('[data-gd-product-thumb]'));

    const showMedia = (mediaId) => {
      if (!mediaId || !slides.length) return;
      let matched = false;
      slides.forEach((slide) => {
        const active = slide.dataset.mediaId === mediaId;
        slide.hidden = !active;
        if (active) matched = true;
      });
      if (!matched) return;
      thumbs.forEach((thumb) => {
        thumb.setAttribute('aria-pressed', String(thumb.dataset.mediaId === mediaId));
      });
    };

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => showMedia(thumb.dataset.mediaId));
    });

    const variants = Array.from(root.querySelectorAll('[data-gd-variant]'));
    const price = root.querySelector('[data-gd-product-price]');
    const compare = root.querySelector('[data-gd-product-compare]');
    const availability = root.querySelector('[data-gd-product-availability]');
    const submit = root.querySelector('[data-gd-product-submit]');
    const submitLabel = root.querySelector('[data-gd-product-submit-label]');
    const dynamicCheckout = root.querySelector('[data-gd-dynamic-checkout]');

    const updateVariant = (input) => {
      if (!input) return;
      const available = input.dataset.available === 'true';
      if (price) price.textContent = input.dataset.price || '';
      if (compare) {
        const compareValue = input.dataset.compare || '';
        compare.textContent = compareValue;
        compare.hidden = !compareValue;
      }
      if (availability) {
        availability.textContent = available ? 'Available' : 'Collected';
        availability.classList.toggle('is-unavailable', !available);
      }
      if (submit) submit.disabled = !available;
      if (submitLabel) submitLabel.textContent = available ? (submitLabel.dataset.availableLabel || 'Add to Bag') : 'Collected';
      if (dynamicCheckout) dynamicCheckout.hidden = !available;
      if (input.dataset.mediaId) showMedia(input.dataset.mediaId);

      const url = new URL(window.location.href);
      url.searchParams.set('variant', input.value);
      window.history.replaceState({}, '', url);
    };

    if (submitLabel) submitLabel.dataset.availableLabel = submitLabel.textContent.trim() || 'Add to Bag';
    variants.forEach((input) => input.addEventListener('change', () => updateVariant(input)));
  };

  const init = () => document.querySelectorAll('[data-gd-product]').forEach(initProduct);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
